import { useGetUsersQuery } from "../../redux/features/users/userAPI";
import { useGetAssignmentMarksQuery } from "../../redux/features/assignments/assignmentMarkAPI";
import { useGetQuizMarksQuery } from "../../redux/features/quiz/quizMarkAPI";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import usePageTitle from "../../utils/usePageTitle";

export default function Leaderboard() {
  usePageTitle("Leaderboard");

  const { studentId: sId } = useParams();
  const [studentId, setStudentId] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const { id } = JSON.parse(localStorage.auth).user;
    setStudentId(id);

    if (id === 1) navigate("/admin/dashboard");
    if (id !== Number(sId)) navigate("/");
  }, [navigate, sId]);

  const {
    data: users,
    isLoading: usersIsLoading,
    isError: usersIsError,
  } = useGetUsersQuery();

  const {
    data: assignmentMarks,
    isLoading: assignmentMarksIsLoading,
    isError: assignmentMarksIsError,
  } = useGetAssignmentMarksQuery();

  const {
    data: quizMarks,
    isLoading: quizMarksIsLoading,
    isError: quizMarksIsError,
  } = useGetQuizMarksQuery();

  let content = null;
  let prevTotal = Number.MAX_VALUE;
  let rank = 0;

  let heroName = "";
  let heroAssignmentResult = 0;
  let heroQuizResult = 0;
  let heroRank = 0;

  if (
    !assignmentMarksIsLoading &&
    !assignmentMarksIsError &&
    !quizMarksIsLoading &&
    !quizMarksIsError &&
    !usersIsLoading &&
    !usersIsError &&
    users.length > 0
  ) {
    const userList = users.map((user) => {
      let assignmentResult = 0;
      let quizResult = 0;
      let total = 0;

      assignmentResult = assignmentMarks?.reduce(
        (total, current) =>
          current.student_id === user.id ? total + current.mark : total,
        0
      );
      quizResult = quizMarks?.reduce(
        (total, current) =>
          current.student_id === user.id ? total + current.mark : total,
        0
      );
      total = assignmentResult + quizResult;

      return user.role === "admin"
        ? { key: user.id }
        : {
            key: user.id,
            name: user.name,
            assignmentResult,
            quizResult,
            total,
          };
    });

    userList.sort((a, b) => b?.total - a?.total);

    content = userList.slice(0, 20).map((user) => {
      if (user.total < prevTotal) {
        rank++;
        prevTotal = user.total;
      }

      if (user.key === studentId) {
        heroName = user.name;
        heroAssignmentResult = user.assignmentResult;
        heroQuizResult = user.quizResult;
        heroRank = rank;
      }

      return (
        user.name && (
          <tr className="border-b border-slate-600/50" key={user.key}>
            <td className="table-td text-center border border-slate-600/50">
              <span className="text-cyan">{rank === 1 ? "🏆" : rank}</span>
            </td>
            <td className="table-td text-center border border-slate-600/50 ">
              <span className="text-cyan">{user.name}</span>
            </td>
            <td className="table-td text-center border border-slate-600/50">
              {user.quizResult}
            </td>
            <td className="table-td text-center border border-slate-600/50">
              {user.assignmentResult}
            </td>
            <td className="table-td text-center border border-slate-600/50">
              <span className="text-cyan">{user.total}</span>
            </td>
          </tr>
        )
      );
    });
  }

  return (
    <>
      <section className="py-6 bg-primary" style={{ paddingTop: "100px" }}>
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div>
            <h3 className="text-lg font-bold ">Your Position in Leaderboard</h3>
            <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
              <thead>
                <tr className="hover:bg-slate-200">
                  <th className="table-th !text-center border border-slate-600/50">
                    Rank
                  </th>
                  <th className="table-th !text-center border border-slate-600/50">
                    Name
                  </th>
                  <th className="table-th !text-center border border-slate-600/50">
                    Quiz Mark
                  </th>
                  <th className="table-th !text-center border border-slate-600/50">
                    Assignment Mark
                  </th>
                  <th className="table-th !text-center border border-slate-600/50">
                    Total
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr className="border-2 border-cyan">
                  <td className="table-td text-center font-bold border border-slate-600/50">
                    <span className="text-cyan">
                      {heroRank === 1 ? "🏆" : heroRank}
                    </span>
                  </td>
                  <td className="table-td text-center font-bold border border-slate-600/50">
                    <span className="text-cyan">{heroName}</span>
                  </td>
                  <td className="table-td text-center font-bold border border-slate-600/50">
                    {heroQuizResult}
                  </td>
                  <td className="table-td text-center font-bold border border-slate-600/50">
                    {heroAssignmentResult}
                  </td>
                  <td className="table-td text-center font-bold border border-slate-600/50">
                    <span className="text-cyan">
                      {heroAssignmentResult + heroQuizResult}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="my-8">
            <h3 className="text-lg font-bold">Top 20 Result</h3>
            <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
              <thead>
                <tr className="border-b border-slate-600/50">
                  <th className="table-th !text-center border border-slate-600/50">
                    Rank
                  </th>
                  <th className="table-th !text-center border border-slate-600/50">
                    Name
                  </th>
                  <th className="table-th !text-center border border-slate-600/50">
                    Quiz Mark
                  </th>
                  <th className="table-th !text-center border border-slate-600/50">
                    Assignment Mark
                  </th>
                  <th className="table-th !text-center border border-slate-600/50">
                    Total
                  </th>
                </tr>
              </thead>

              <tbody>{content}</tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
}
